export default __webpack_public_path__ + "static/media/switch_on.8392875f.mp3";